import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=template&id=cc81337e"
import script from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports